import { Routes, Route, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Sidebar, { useSidebarToggle } from "../Sidebar/Sidebar";
import Login from "../Login/Login";
import News from "../News/News";
import Newsadd from "../News/Newsadd"
import Newsedit from "../News/Newsedit";
import Newspreview from "../News/Newspreview";
import NewsView from "../News/Newsview";
import FAQ from "../FAQ/FAQ";
import FAQAdd from "../FAQ/FAQAdd";
import FAQEdit from "../FAQ/FAQEdit";
import Faqpreview from "../FAQ/FAQPreview";
import FAQView from "../FAQ/FAQview";
import Category from "../FAQ/Category/Category";
import CategoryAdd from "../FAQ/Category/Categoryadd";
import CategoryEdit from "../FAQ/Category/Categoryedit";
import Blog from "../Blog/Blog";
import BlogAdd from "../Blog/Blogadd";
import BlogEdit from "../Blog/Blogedit";
import BlogPreview from "../Blog/Blogpreview";
import BlogView from "../Blog/Blogview";
import ContactUs from "../ContactUs/ContactUs";
import EditSocial from "../ContactUs/EditSocial";
import EditContact from "../ContactUs/EditContact";
import EditAsra from "../ContactUs/AsraImpact";
import EditMap from "../ContactUs/EditMap";
import Admin from "../Admin/Admin";
import Adminadd from "../Admin/Adminadd";
import Adminedit from "../Admin/Adminedit";
import AdminView from "../Admin/Adminview";
import BlogTag from "../Blog/BlogTag/Blogtag";
import NewsCategory from "../News/NewsCategory/NewsCategory";
import NewsCategoryAdd from "../News/NewsCategory/NewsCategoryadd";
import NewsCategoryEdit from "../News/NewsCategory/NewsCategoryedit";
import Services from "../Services/Services";
import OurServices from "../Services/OurServices";
import OurServicesPreview from "../Services/OurServicesPreview"
import HowItWorkPreview from "../Services/HowItWorkPreview"
import WhyChooseUsPreview from "../Services/WhyChooseUsPreview"
import ServicesAdd from "../Services/ServicesAdd";
import ServicesEdit from "../Services/ServicesEdit";
import WhyChooseUsEdit from "../Services/WhyChooseUsEdit";
import HowItWorkEdit from "../Services/HowItWorkEdit";
import OurGalleryEdit from "../Services/OurGallery";
import BannerEdit from "../Services/Banner";
import AboutUs from "../About/Aboutus";
import AboutUsEdit from "../About/Aboutusedit";
import FounderEdit from "../About/Founderedit";
import OurstoryEdit from "../About/Ourstoryedit";
import AboutBannerEdit from "../About/AboutBannerEdit";
import OurMissionEdit from "../About/ourmissionedit";
import EligibilityBannerEdit from "../Eligibility/EligibilityBannerEdit";
import Eligibility from "../Eligibility/Eligibility";
import EligibilityEdit from "../Eligibility/Eligibilityedit";
import EligibilityLabel from "../Eligibility/EligibilityLabel/EligibilityLabel";
import EligibilityCandidate from "../Eligibility/EligibilityLabel/EligibilityCandidate";
import EligibilityCandidateView from "../Eligibility/EligibilityLabel/EligibilityCandidateView";
import HomePage from "../Home/Home";
import TestimonialEdit from "../Home/Testimonialedit";
import TestimonialVideoAdd from "../Home/Testimonialvideoadd";
import TestimonialVideoEdit from "../Home/TestimonialVideoEdit";
import TestimonialReviewAdd from "../Home/TestimonialReviewAdd";
import TestimonialReviewEdit from "../Home/TestimonialReviewEdit";
import VisaHomeEdit from "../Home/VisaHomeEdit";
import Contactusform from "../ContactUsForm/Contactusform";
import ContactusformView from "../ContactUsForm/ContactusformView";
import HeroBanner from "../Home/HeroBanner";
import Consultation from "../Consultation/Consultation";
import IntakeFormEdit from "../Consultation/IntakeFormEdit"
import ConsultationFromList from "../Consultation/ConsultationFromList/ConsultationFromList"
import ConsultationFromView from "../Consultation/ConsultationFromList/ConsultationFromView"
import ConsultationEdit from "../Consultation/ConsultationFromList/ConsultationEdit";
import ScrollToTop from "../ScrollToTop";
import Calender from "../../Pages/Consultation/Calender";
import ConsultationTimeSlot from "../../Pages/Consultation/ConsultationFromList/ConsultationTimeSlot";
import PrimaryInfo from "../Consultation/ConsultationFromList/PrimaryInfo";
import BookingConfirmation from "../Consultation/ConsultationFromList/BookingConfirmation";
import PaymentRequest from "../Consultation/ConsultationFromList/PaymentRequest";
import ProtectedRoute from "../ProtectedRoute";
import OldConsultationFromList from "../OldConsultation/OldConsultationFromList/OldConsultationFromList"
import OldConsultationEdit from "../OldConsultation/OldConsultationFromList/OldConsultationEdit";
import OldCalendar from "../../Pages/OldConsultation/OldCalendar";

const RouterApp = () => {
    const location = useLocation();
    const isLoggedIn = sessionStorage.getItem("isAdminLoggedIn") === "true";
    const hideLayout = location.pathname === "/" || !isLoggedIn;
    const { isOpen } = useSidebarToggle();

    return (
        <div>
            {!hideLayout && <Header />}
            {!hideLayout && <Sidebar />}
            <ScrollToTop />
               <main
                className={
                    hideLayout
                        ? ""
                        : `main-content ${isOpen ? "content-shifted" : "content-full"}`
                }

                
            >
            <Routes>
                <Route path="/" element={<Login />} />
                <Route element={<ProtectedRoute />}>
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/adminadd" element={<Adminadd />} />
                    <Route path="/adminedit/:id" element={<Adminedit />} />
                    <Route path="/adminview/:id" element={<AdminView />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/newsadd" element={<Newsadd />} />
                    <Route path="/newsedit/:id" element={<Newsedit />} />
                    <Route path="/newspreview" element={<Newspreview />} />
                    <Route path="/newsview/:id" element={<NewsView />} />
                    <Route path="/newscategory" element={<NewsCategory />} />
                    <Route path="/newscategoryadd" element={<NewsCategoryAdd />} />
                    <Route path="/newscategoryedit/:id" element={<NewsCategoryEdit />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="blogadd" element={<BlogAdd />} />
                    <Route path="/blogedit/:id" element={<BlogEdit />} />
                    <Route path="/Blogpreview" element={<BlogPreview />} />
                    <Route path="/blogview/:id" element={<BlogView />} />
                    <Route path="/blogtag" element={<BlogTag />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/faqadd" element={<FAQAdd />} />
                    <Route path="/faqedit/:id" element={<FAQEdit />} />
                    <Route path="/faqpreview" element={<Faqpreview />} />
                    <Route path="/faqview/:id" element={<FAQView />} />
                    <Route path="/category" element={<Category />} />
                    <Route path="/categoryadd" element={<CategoryAdd />} />
                    <Route path="/categoryedit/:id" element={<CategoryEdit />} />
                    <Route path="/contactus" element={<ContactUs />} />
                    <Route path="/editsocial" element={<EditSocial />} />
                    <Route path="/editcontact" element={<EditContact />} />
                    <Route path="/editasra" element={<EditAsra />} />
                    <Route path="/editmap" element={<EditMap />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/ourservices/:id" element={<OurServices />} />
                    <Route path="/OurServicesPreview" element={<OurServicesPreview />} />
                    <Route path="/HowItWorkPreview" element={<HowItWorkPreview />} />
                    <Route path="/WhyChooseUsPreview" element={<WhyChooseUsPreview />} />
                    <Route path="/servicesadd/:id" element={<ServicesAdd />} />
                    <Route path="/servicesedit/:id" element={<ServicesEdit />} />
                    <Route path="/whychooseusedit/:id" element={<WhyChooseUsEdit />} />
                    <Route path="/howitworkedit/:id" element={<HowItWorkEdit />} />
                    <Route path="/ourgalleryedit/:id" element={<OurGalleryEdit />} />
                    <Route path="/banneredit" element={<BannerEdit />} />
                    <Route path="/aboutus" element={<AboutUs />} />
                    <Route path="/aboutusedit/:id" element={<AboutUsEdit />} />
                    <Route path="/founderedit/:id" element={<FounderEdit />} />
                    <Route path="/ourstoryedit/:id" element={<OurstoryEdit />} />
                    <Route path="/aboutbanneredit" element={<AboutBannerEdit />} />
                    <Route path="/ourmissionedit/:id" element={<OurMissionEdit />} />
                    <Route path="/eligibilitybanneredit" element={<EligibilityBannerEdit />} />
                    <Route path="/eligibility" element={<Eligibility />} />
                    <Route path="/eligibilityedit/:id" element={<EligibilityEdit />} />
                    <Route path="/eligibilitylabel" element={<EligibilityLabel />} />
                    <Route path="/eligibilitycandidate" element={<EligibilityCandidate />} />
                    <Route path="/eligibilitycandidateview/:id" element={<EligibilityCandidateView />} />
                    <Route path="/homepage" element={<HomePage />} />
                    <Route path="/herobanner" element={<HeroBanner />} />
                    <Route path="/testimonialedit/:id" element={<TestimonialEdit />} />
                    <Route path="/testimonialvideoadd" element={<TestimonialVideoAdd />} />
                    <Route path="/testimonialvideoedit/:id" element={<TestimonialVideoEdit />} />
                    <Route path="/TestimonialReviewAdd" element={<TestimonialReviewAdd />} />
                    <Route path="/TestimonialReviewEdit/:id" element={<TestimonialReviewEdit />} />
                    <Route path="/VisaHomeEdit/:id" element={<VisaHomeEdit />} />
                    <Route path="/contactusform" element={<Contactusform />} />
                    <Route path="/contactusformview/:id" element={<ContactusformView />} />
                    <Route path="/Consultation" element={<Consultation />} />
                    <Route path="IntakeFormEdit" element={<IntakeFormEdit />} />
                    <Route path="ConsultationFromList" element={<ConsultationFromList />} />
                    <Route path="ConsultationFromView/:id" element={<ConsultationFromView />} />
                    <Route path="ConsultationEdit/:id" element={<ConsultationEdit />} />
                    <Route path="/calender" element={<Calender />} />
                    <Route path="/consultationtimeslot" element={<ConsultationTimeSlot />} />
                    <Route path="/bookingconfirmation" element={<BookingConfirmation />} />
                    <Route path="/paymentrequest" element={<PaymentRequest />} />
                    <Route path="PrimaryInfo" element={<PrimaryInfo />} />
                    <Route path="OldConsultationFromList" element={<OldConsultationFromList />} />
                    <Route path="OldConsultationEdit/:id" element={<OldConsultationEdit />} />
                    <Route path="/OldCalender" element={<OldCalendar />} />
                </Route>
            </Routes>
            </main>
        </div>
    );
};

export default RouterApp;
